import React from "react";

const typeStyles = {
  success: {
    iconColor: "text-green-500",
    bgColor: "bg-green-100",
    darkBg: "dark:bg-green-800 dark:text-green-200",
    svgPath: (
      <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
    ),
  },
  error: {
    iconColor: "text-red-500",
    bgColor: "bg-red-100",
    darkBg: "dark:bg-red-800 dark:text-red-200",
    svgPath: (
      <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 11.793a1 1 0 1 1-1.414 1.414L10 11.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L8.586 10 6.293 7.707a1 1 0 0 1 1.414-1.414L10 8.586l2.293-2.293a1 1 0 0 1 1.414 1.414L11.414 10l2.293 2.293Z" />
    ),
  },
  warning: {
    iconColor: "text-orange-500",
    bgColor: "bg-orange-100",
    darkBg: "dark:bg-orange-700 dark:text-orange-200",
    svgPath: (
      <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM10 15a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm1-4a1 1 0 0 1-2 0V6a1 1 0 0 1 2 0v5Z" />
    ),
  },
  info: {
    iconColor: "text-blue-500",
    bgColor: "bg-blue-100",
    darkBg: "dark:bg-blue-700 dark:text-blue-200",
    svgPath: (
      <path d="M10 0a10 10 0 1 0 10 10A10.011 10.011 0 0 0 10 0Zm.75 15.25h-1.5v-6h1.5Zm0-8h-1.5v-1.5h1.5Z" />
    ),
  },
};

export default function ToastItem({ title, description, type = "info" }) {
  const { iconColor, bgColor, darkBg, svgPath } = typeStyles[type] || typeStyles.info;

  return (
    <div
      className="flex items-center w-full max-w-xs p-4 text-gray-700 bg-white rounded-lg shadow-sm dark:text-gray-200 dark:bg-gray-800"
      role="alert"
    >
      <div className={`inline-flex items-center justify-center w-8 h-8 ${iconColor} ${bgColor} rounded-lg ${darkBg}`}>
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          {svgPath}
        </svg>
      </div>
      <div className="ms-3 text-sm font-medium">
        <p className="font-semibold">{title}</p>
        {description && <p>{description}</p>}
      </div>
    </div>
  );
}
